import { LocalStorageUtils } from '@brunommsilva/react-foundations';

const ACCESS_TOKEN_KEY = 'access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';

class TokenStorage {
  private static instance: TokenStorage;

  private constructor() {}

  public static getInstance(): TokenStorage {
    if (!TokenStorage.instance) {
      TokenStorage.instance = new TokenStorage();
    }
    return TokenStorage.instance;
  }

  public getAccessToken(): string | null {
    return LocalStorageUtils.getItem<string>(ACCESS_TOKEN_KEY) ?? null;
  }

  public setAccessToken(token: string): void {
    LocalStorageUtils.setItem(ACCESS_TOKEN_KEY, token);
  }

  public removeAccessToken(): void {
    LocalStorageUtils.removeItem(ACCESS_TOKEN_KEY);
  }

  public getRefreshToken(): string | null {
    return LocalStorageUtils.getItem<string>(REFRESH_TOKEN_KEY) ?? null;
  }

  public setRefreshToken(token: string): void {
    LocalStorageUtils.setItem(REFRESH_TOKEN_KEY, token);
  }

  public removeRefreshToken(): void {
    LocalStorageUtils.removeItem(REFRESH_TOKEN_KEY);
  }

  public clearTokens(): void {
    this.removeAccessToken();
    this.removeRefreshToken();
  }
}

const tokenStorage = TokenStorage.getInstance();
export default tokenStorage;
